if (!customElements.get('featured-review')) {
  customElements.define(
    'featured-review',
    class FeaturedReview extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-featured-review-button]');
        if (!this.button) return;

        this.updateButtonVisibility = this.updateButtonVisibility.bind(this);
        this.button.addEventListener('click', () => this.scrollToReviews());
        // Reviews section can be swapped after this element on product re-render
        document.addEventListener('product:rerendered', this.updateButtonVisibility);
        this.updateButtonVisibility();
      }

      disconnectedCallback() {
        if (this.updateButtonVisibility) {
          document.removeEventListener('product:rerendered', this.updateButtonVisibility);
        }
      }

      // Hide the CTA when there's no reviews section to scroll to
      updateButtonVisibility() {
        this.button.hidden = !document.querySelector('product-reviews');
      }

      scrollToReviews() {
        const reviewsSection = document.querySelector('product-reviews');
        if (!reviewsSection) return;
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  );
}
